import { useCallback } from "react";
import { useElements, useStripe } from "@stripe/react-stripe-js";
import { CheckoutError } from "./CheckoutError";

export const useGetStripeElements = () => {
  const stripe = useStripe();
  const elements = useElements();

  const getStripeElements = useCallback(
    (caller: string) => {
      if (!elements || !stripe) {
        throw CheckoutError.stripeNotInitialized(caller);
      }
      return { elements, stripe };
    },
    [elements, stripe],
  );

  return getStripeElements;
};
